// src/components/ServicesSection.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../components/ServicesSection.css';

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome, 
  faTools, 
  faShieldAlt, 
  faArrowRight, 
  faBuilding,
  faWrench,
  faHardHat
} from '@fortawesome/free-solid-svg-icons';

function ServicesSection() {
  const [animated, setAnimated] = useState(false);
  const [activeService, setActiveService] = useState(null);

  // Animation on scroll
  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector('.services-section');
      if (!element) return;
      
      const position = element.getBoundingClientRect();
      if (position.top < window.innerHeight * 0.75 && !animated) {
        setAnimated(true);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [animated]);

  // Services data
  const services = [
    {
      id: 'new-roof',
      icon: faHome,
      title: 'New Roof Installation',
      description: 'Expert installation of high-quality roofing materials tailored to your property\'s needs.',
      link: '/services#new-roofs'
    },
    {
      id: 'repairs',
      icon: faTools,
      title: 'Roof Repairs',
      description: 'Fast, reliable repairs for leaks, storm damage, and general wear and tear.',
      link: '/services#repairs'
    },
    {
      id: 'maintenance',
      icon: faShieldAlt,
      title: 'Roof Maintenance',
      description: 'Preventative care to extend your roof\'s lifespan and identify issues early.',
      link: '/services#maintenance'
    },
    {
      id: 'flat-roofing',
      icon: faBuilding,
      title: 'Flat Roofing Solutions',
      description: 'Specialized installation and repair of flat roofing systems for optimal performance.',
      link: '/services#flat-roofing'
    },
    {
      id: 'guttering',
      icon: faWrench,
      title: 'Guttering & Fascias',
      description: 'Complete guttering services including installation, replacement, and maintenance.',
      link: '/services#guttering'
    },
    {
      id: 'chimney',
      icon: faHardHat,
      title: 'Chimney Repairs',
      description: 'Expert chimney repairs, rebuilding, and maintenance to ensure structural integrity.',
      link: '/services#chimney'
    }
  ];

  return (
    <section className="services-section">
      <div className="container">
        <div className={`section-header ${animated ? 'animated' : ''}`}>
          <h2 className="section-title">Our Premier Roofing Services</h2>
          <p className="section-description">
            We provide comprehensive roofing solutions to protect and enhance your property
          </p>
        </div>

        <div className={`services-grid ${animated ? 'animated' : ''}`}>
          {services.map((service, index) => (
            <div 
              key={service.id}
              className={`service-card ${activeService === service.id ? 'active' : ''}`}
              onMouseEnter={() => setActiveService(service.id)}
              onMouseLeave={() => setActiveService(null)}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-icon">
                <FontAwesomeIcon icon={service.icon} />
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              {/* Removed individual Learn More links */}
            </div>
          ))}
        </div>

        <div className={`services-cta ${animated ? 'animated' : ''}`}>
          <Link to="/services" className="services-btn">
            View All Services <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;